module.exports = __webpack_public_path__ + "static/media/fssaiIcon.fd298d1e.svg";